module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7fe26de7358fc4e31261bb1e8038751b.png";